import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
  EngineeringFindingState,
} from "@insights/contracts";
import {
  engineeringFindingEvidenceOpened,
  getCollaboration,
  getEngineeringFindings,
  updateEngineeringFinding,
  type EngineeringFindingsFilters,
} from "../../../api/services/engineering-findings";

export type DecisionInboxFilters = EngineeringFindingsFilters;

export function useCollaboration(
  workspaceId: string | undefined,
  filters: Pick<DecisionInboxFilters, "repository" | "teamId">,
) {
  return useQuery({
    queryKey: ["collaboration", workspaceId, filters],
    queryFn: () => getCollaboration(workspaceId!, filters),
    enabled: Boolean(workspaceId),
  });
}

export function useDecisionInbox(
  workspaceId: string | undefined,
  filters: DecisionInboxFilters,
) {
  return useQuery({
    queryKey: ["decision-inbox", workspaceId, filters],
    queryFn: () => getEngineeringFindings(workspaceId!, filters),
    enabled: Boolean(workspaceId),
  });
}

export function useUpdateFinding(workspaceId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      findingId,
      state,
      dismissalReason,
    }: {
      findingId: string;
      state: EngineeringFindingState;
      dismissalReason?: string | null;
    }) => updateEngineeringFinding(
      workspaceId!,
      findingId,
      state,
      dismissalReason,
    ),
    onSuccess: () => queryClient.invalidateQueries({
      queryKey: ["decision-inbox", workspaceId],
    }),
  });
}

export function useRecordEvidenceOpen(workspaceId: string | undefined) {
  return useMutation({
    mutationFn: (findingId: string) => engineeringFindingEvidenceOpened(
      workspaceId!,
      findingId,
    ),
  });
}
